/**
 * 最近搜索工具函数
 * 用于在多个组件间共享最近搜索功能
 */

export interface RecentSearch {
  symbol: string;
  name: string;
  timestamp: number;
}

const RECENT_SEARCHES_KEY = 'stock-recent-searches';
const MAX_RECENT_SEARCHES = 10;

/**
 * 获取最近搜索列表
 */
export function getRecentSearches(): RecentSearch[] {
  try {
    const stored = localStorage.getItem(RECENT_SEARCHES_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

/**
 * 保存最近搜索列表
 */
export function saveRecentSearches(searches: RecentSearch[]): void {
  localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(searches));
}

/**
 * 添加一条搜索记录
 * @param symbol 股票代码
 * @param name 股票名称（可选，后续可更新）
 */
export function addRecentSearch(symbol: string, name?: string): RecentSearch[] {
  const searches = getRecentSearches();
  const existing = searches.find(s => s.symbol === symbol);
  const displayName = name || existing?.name || symbol;
  
  const filtered = searches.filter(s => s.symbol !== symbol);
  const updated = [
    { symbol, name: displayName, timestamp: Date.now() },
    ...filtered,
  ].slice(0, MAX_RECENT_SEARCHES);
  
  saveRecentSearches(updated);
  return updated;
}

/**
 * 更新搜索记录的名称（当获取到股票名称时调用）
 */
export function updateRecentSearchName(symbol: string, name: string): RecentSearch[] {
  const searches = getRecentSearches();
  const updated = searches.map(s => 
    s.symbol === symbol ? { ...s, name } : s
  );
  saveRecentSearches(updated);
  return updated;
}

/**
 * 删除一条搜索记录
 */
export function removeRecentSearch(symbol: string): RecentSearch[] {
  const searches = getRecentSearches();
  const updated = searches.filter(s => s.symbol !== symbol);
  saveRecentSearches(updated);
  return updated;
}

/**
 * 清空所有搜索记录
 */
export function clearRecentSearches(): void {
  localStorage.removeItem(RECENT_SEARCHES_KEY);
}
